
import { Link } from "react-router-dom";

const LaunchpadDropsCard = ({collection}) => {
    return(
        <Link to = {`/launchpad/${collection.name}`} className="home_collection_card flex flex-col rounded-[10px] pb-3 border-[#b3b3b3] dark:border-gray-800 border-[1px] 
                        mx-3 mb-3 max-w-[200px]">
            <div className="overflow-hidden mb-3">
                <img src = {collection.image} alt = {collection.name} className = "collection_card_img w-full h-full object-cover rounded-t-[10px]" />
            </div>

            <div className="flex flex-col px-2">
                <div className="dark:text-white">
                    <h3 className="text-center text-sm lg:text-base xl:text-lg font-bold">{collection.name}</h3>
                </div>
                <div className="dark:text-white">
                    <h3 className="text-center text-[12px] xl:text-[14px] 2xl:text-[16px] text-main">{collection.name}</h3>
                </div>
                <div className="">
                    <p className="text-center text-[12px] xl:text-[14px] 2xl:text-[16px] text-slate-500 dark:text-gray-300">
                        10d 30h 50m
                    </p>
                </div>
                
            </div>

        </Link>
    )
}

export default LaunchpadDropsCard;